import React, { useState } from "react";
import { Card, Tabs, Typography, Space, Row, Col, Radio } from "antd";

const { Title, Paragraph, Text } = Typography;

const AIvsMLComparison = () => {
  const [selectedTimeframe, setSelectedTimeframe] = useState("all");

  const comparisonData = [
    {
      concept: "Definition",
      ai: "Making machines think and act intelligently like humans",
      ml: "A method that enables machines to learn from data without explicit programming",
    },
    {
      concept: "Scope",
      ai: "Broad field including reasoning, perception, robotics, NLP, etc.",
      ml: "Subset focused on algorithms that improve with experience",
    },
    {
      concept: "Goal",
      ai: "Create intelligent systems that can perform any intellectual task",
      ml: "Enable computers to learn patterns and make predictions from data",
    },
    {
      concept: "Data Dependency",
      ai: "Can work with or without large datasets",
      ml: "Heavily dependent on quality and quantity of data",
    },
    {
      concept: "Learning Method",
      ai: "May or may not learn; can use pre-programmed rules",
      ml: "Must learn and improve from experience/data",
    },
    {
      concept: "Examples",
      ai: "Self-driving cars, virtual assistants, game-playing AI",
      ml: "Spam filters, recommendation systems, image recognition",
    },
  ];

  const timelineData = [
    {
      year: "1950s–1970s",
      event:
        "AI was born. Alan Turing started the field. Early programs tried solving problems with rules, and the first simple neural networks appeared.",
    },
    {
      year: "1960s–1980s",
      event:
        "Expert systems used rules to help in areas like medicine. Neural networks kept developing, but computers were too weak to make them powerful yet.",
    },
    {
      year: "1980s–1990s",
      event:
        "New machine learning techniques like support vector machines became popular.",
    },
    {
      year: "1997",
      event:
        "IBM’s Deep Blue beat world chess champion Garry Kasparov. This showed AI could beat humans at very complex games.",
    },
    {
      year: "2000s–2010s",
      event:
        "AI started showing up in everyday life — Siri, Watson, and recommendation systems. In 2012, AlexNet shocked the world by recognizing images far better than older systems, starting the deep learning boom.",
    },
    {
      year: "2016",
      event:
        "AlphaGo beat the best Go player, proving AI could master games even harder than chess using deep reinforcement learning.",
    },
    {
      year: "2020s–Present",
      event:
        "Huge AI models like GPT became common. They can write text, create images, and more. Companies make Artificial General Intelligence (AGI) as their mission.",
    },
  ];

  const applicationsData = [
    {
      category: "Healthcare",
      aiExample: "IBM Watson for medical diagnosis assistance",
      mlExample: "Cancer detection from medical imaging",
    },
    {
      category: "Transportation",
      aiExample: "Tesla Autopilot's full self-driving system",
      mlExample: "Uber's surge pricing prediction",
    },
    {
      category: "Entertainment",
      aiExample: "Creating Non-Player Characters (NPCs) in video games",
      mlExample: "Netflix recommendation algorithm",
    },
    {
      category: "Finance",
      aiExample: "Fraud detection with reasoning",
      mlExample: "Stock price prediction models",
    },
  ];

  const filteredTimeline =
    selectedTimeframe === "all"
      ? timelineData
      : timelineData.filter(
          (item) => item.type === selectedTimeframe || item.type === "both"
        );

  // Tab 1: Overview
  const renderOverview = () => (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      {/* <Card title={<span style={{ color: "#0071e3" }}>The Relationship</span>}>
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <div
            style={{
              position: "relative",
              display: "inline-block",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "240px",
                height: "240px",
                borderRadius: "50%",
                border: "3px solid #1890ff",
                backgroundColor: "#e6f7ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                flexDirection: "column",
                paddingTop: "20px",
              }}
            >
              <div style={{ position: "absolute", top: "40px" }}>
                <Text strong style={{ fontSize: "16px", color: "#1890ff" }}>
                  Artificial Intelligence
                </Text>
              </div>

              <div
                style={{
                  width: "110px",
                  height: "110px",
                  borderRadius: "50%",
                  border: "2px solid #52c41a",
                  backgroundColor: "#f6ffed",
                  position: "absolute",
                  bottom: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                }}
              >
                <Text
                  strong
                  style={{
                    fontSize: "13px",
                    color: "#52c41a",
                    textAlign: "center",
                  }}
                >
                  Machine Learning
                </Text>
              </div>
            </div>
          </div>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card size="small" style={{ border: "1px solid #0071e3" }} bodyStyle={{ textAlign: "left" }}>
                <Text strong>AI (Artificial Intelligence)</Text>
                <Paragraph style={{ margin: "8px 0 0 0", fontSize: "14px" }}>
                  The broad science of mimicking human abilities
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card size="small" style={{ border: "1px solid #0071e3" }} bodyStyle={{ textAlign: "left" }}>
                <Text strong>ML (Machine Learning)</Text>
                <Paragraph style={{ margin: "8px 0 0 0", fontSize: "14px" }}>
                  A subset of AI that learns from data
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>

        <Paragraph>
          All Machine Learning is Artificial Intelligence, but not all
          Artificial Intelligence uses Machine Learning. Think of AI as the goal
          of creating intelligent systems, and ML as one of the key methods to
          achieve that goal.
        </Paragraph>
      </Card> */}

      <Card title={<span style={{ color: "#0071e3" }}>The Relationship</span>}>
        <Row gutter={[16, 16]} align="middle">
          {/* Left column: picture */}
          <Col xs={24} md={12} style={{ textAlign: "center" }}>
            <div
              style={{
                position: "relative",
                display: "inline-block",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  width: "240px",
                  height: "240px",
                  borderRadius: "50%",
                  border: "3px solid #1890ff",
                  backgroundColor: "#e6f7ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  flexDirection: "column",
                  paddingTop: "20px",
                }}
              >
                <div style={{ position: "absolute", top: "40px" }}>
                  <Text strong style={{ fontSize: "16px", color: "#1890ff" }}>
                    Artificial Intelligence
                  </Text>
                </div>

                <div
                  style={{
                    width: "110px",
                    height: "110px",
                    borderRadius: "50%",
                    border: "2px solid #52c41a",
                    backgroundColor: "#f6ffed",
                    position: "absolute",
                    bottom: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                  }}
                >
                  <Text
                    strong
                    style={{
                      fontSize: "13px",
                      color: "#52c41a",
                      textAlign: "center",
                    }}
                  >
                    Machine Learning
                  </Text>
                </div>
              </div>
            </div>
          </Col>

          {/* Right column: stacked cards */}
          <Col xs={24} md={12}>
            <Card
              size="small"
              style={{ border: "1px solid #0071e3", marginBottom: "16px" }}
              bodyStyle={{ textAlign: "left" }}
            >
              <Text strong>AI (Artificial Intelligence)</Text>
              <Paragraph style={{ margin: "8px 0 0 0", fontSize: "14px" }}>
                The broad science of mimicking human abilities
              </Paragraph>
            </Card>

            <Card
              size="small"
              style={{ border: "1px solid #0071e3" }}
              bodyStyle={{ textAlign: "left" }}
            >
              <Text strong>ML (Machine Learning)</Text>
              <Paragraph style={{ margin: "8px 0 0 0", fontSize: "14px" }}>
                A subset of AI that learns from data
              </Paragraph>
            </Card>
          </Col>
        </Row>

        <Paragraph style={{ marginTop: "16px" }}>
          All Machine Learning is Artificial Intelligence, but not all
          Artificial Intelligence uses Machine Learning. Think of AI as the goal
          of creating intelligent systems, and ML as one of the key methods to
          achieve that goal.
        </Paragraph>
      </Card>
    </Space>
  );

  // Tab 2: Comparison
  const renderComparison = () => (
    <Card title={<span style={{ color: "#0071e3" }}>AI vs ML</span>}>
      <div className="desktop-table">
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    borderBottom: "2px solid #0071e3",
                    width: "20%",
                  }}
                >
                  <Text strong>Concept</Text>
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    borderBottom: "2px solid #0071e3",
                  }}
                >
                  <Text strong>Artificial Intelligence</Text>
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    borderBottom: "2px solid #0071e3",
                  }}
                >
                  <Text strong>Machine Learning</Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr
                  key={idx}
                  style={{
                    borderBottom:
                      idx < comparisonData.length - 1
                        ? "2px solid #f0f0f0"
                        : "none",
                  }}
                >
                  <td
                    style={{
                      padding: "16px",
                      verticalAlign: "top",
                      textAlign: "left",
                    }}
                  >
                    <Text strong style={{ color: "#0071e3" }}>
                      {row.concept}
                    </Text>
                  </td>
                  <td
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      verticalAlign: "top",
                    }}
                  >
                    {row.ai}
                  </td>
                  <td
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      verticalAlign: "top",
                    }}
                  >
                    {row.ml}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mobile-cards">
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          {comparisonData.map((item, idx) => (
            <Card
              key={idx}
              size="small"
              style={{ border: "1px solid #0071e3", borderRadius: "8px" }}
            >
              <Text strong style={{ color: "#0071e3", fontSize: "16px" }}>
                {item.concept}
              </Text>
              <div style={{ marginTop: "8px" }}>
                <Text strong>AI: </Text>
                <Text>{item.ai}</Text>
              </div>
              <div style={{ marginTop: "8px" }}>
                <Text strong>ML: </Text>
                <Text>{item.ml}</Text>
              </div>
            </Card>
          ))}
        </Space>
      </div>
    </Card>
  );

  // Tab 3
  const renderHistory = () => (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        {timelineData.map((item, index) => (
          <Card
            key={index}
            title={<span style={{ color: "#0071e3" }}>{item.year}</span>}
          >
            <Paragraph style={{ marginBottom: 0 }}>{item.event}</Paragraph>
          </Card>
        ))}
      </Space>
    </Space>
  );

  // Tab 4: Applications
  const renderApplications = () => (
    <Card
      title={<span style={{ color: "#0071e3" }}>Real-World Applications</span>}
    >
      <div className="desktop-table">
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    borderBottom: "2px solid #0071e3",
                    width: "20%",
                  }}
                >
                  <Text strong>Category</Text>
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    borderBottom: "2px solid #0071e3",
                  }}
                >
                  <Text strong>AI Example</Text>
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    borderBottom: "2px solid #0071e3",
                  }}
                >
                  <Text strong>ML Example</Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {applicationsData.map((row, idx) => (
                <tr
                  key={idx}
                  style={{
                    borderBottom:
                      idx < applicationsData.length - 1
                        ? "2px solid #f0f0f0"
                        : "none",
                  }}
                >
                  <td
                    style={{
                      padding: "16px",
                      verticalAlign: "top",
                      textAlign: "left",
                    }}
                  >
                    <Text strong style={{ color: "#0071e3" }}>
                      {row.category}
                    </Text>
                  </td>
                  <td
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      verticalAlign: "top",
                    }}
                  >
                    {row.aiExample}
                  </td>
                  <td
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      verticalAlign: "top",
                    }}
                  >
                    {row.mlExample}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mobile-cards">
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          {applicationsData.map((item, idx) => (
            <Card
              key={idx}
              size="small"
              style={{ border: "1px solid #0071e3", borderRadius: "8px" }}
            >
              <Text strong style={{ color: "#0071e3", fontSize: "16px" }}>
                {item.category}
              </Text>
              <div style={{ marginTop: "8px" }}>
                <Text strong>AI Example: </Text>
                <Text>{item.aiExample}</Text>
              </div>
              <div style={{ marginTop: "8px" }}>
                <Text strong>ML Example: </Text>
                <Text>{item.mlExample}</Text>
              </div>
            </Card>
          ))}
        </Space>
      </div>
    </Card>
  );

  const tabItems = [
    { key: "overview", label: "Overview", children: renderOverview() },
    { key: "comparison", label: "Comparison", children: renderComparison() },
    { key: "history", label: "History", children: renderHistory() },
    {
      key: "applications",
      label: "Real Uses",
      children: renderApplications(),
    },
  ];

  return (
    <div className="page-container">
      <header
        style={{ textAlign: "center", marginBottom: "32px" }}
        className="fade-in-down"
      >
        <Title level={1}>AI vs ML</Title>
        <Paragraph style={{ fontSize: "18px" }}>
          Understanding the relationship and differences between AI and ML
        </Paragraph>
      </header>

      <Tabs defaultActiveKey="overview" items={tabItems} size="large" />

      <style>{`
        @media (min-width: 769px) {
          .desktop-table { display: block; }
          .mobile-cards { display: none; }
        }
        @media (max-width: 768px) {
          .desktop-table { display: none; }
          .mobile-cards { display: block; }
        }
      `}</style>
    </div>
  );
};

export default AIvsMLComparison;
